let singleton = Symbol();
let singletonEnforcer = Symbol();

class ContentModel {
    public data: any;

    constructor(enforcer) {
        if (enforcer !== singletonEnforcer) {
            throw new Error('Cannot construct ContentModel singleton');
        }

        this.data = {};
    }

    static get instance() {
        if (!this[singleton]) {
            this[singleton] = new ContentModel(singletonEnforcer);
        }

        return this[singleton];
    }

    getViews() {
        return this.data.views;
    }

    setData(data) {
        this.data = data;
    }

    getData() {
        return this.data;
    }

    getViewDataByID(id) {
        return this.data.views[id] || {};
    }

    getCommonData() {
        return this.data.common || {};
    }

    getShareData() {
        return this.data.sharing || {};
    }

    getLoggingData() {
        return this.data.logging || {};
    }
}

export default ContentModel;
